// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/client/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"io2Ex8W_9nk0lhd7000M8"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/client";import * as Sentry from "@sentry/nextjs";

// Initialize Sentry in production or when explicitly enabled locally
const sentryEnabled =
  process.env.NODE_ENV === "production" ||
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  process.env.NEXT_PUBLIC_ENABLE_LOCAL_SENTRY === "true";

if (sentryEnabled) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    normalizeDepth: 4, // lets us log more of the error under "extra"

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // Set the environment from the environment variable
    environment:
      process.env.NEXT_PUBLIC_ENV ||
      `vercel-${process.env.NEXT_PUBLIC_VERCEL_ENV}`,
  });
}
